import { GenericCollectionFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const ProtectLogsCollection = GenericCollectionFactory(GENERIC_IDS.PROTECT);